import { render, staticRenderFns } from "./copySalesContract.vue?vue&type=template&id=2b801e3d"
import script from "./copySalesContract.vue?vue&type=script&lang=js"
export * from "./copySalesContract.vue?vue&type=script&lang=js"
import style0 from "./copySalesContract.vue?vue&type=style&index=0&id=2b801e3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports